module.exports ={
  title: ['收结汇','Coll& Settle'],
  downloadOrderTemplate: ['下载订单模板','Download Order Template'],
  viewOrder: ['查看订单','View Order'],
  createCollSettle: ['发起收结汇','Initiate Coll& Settle'],
  tips_label: ['温馨提示：','Tips:'],
  tips_content: ['根据易生合作银行国际收支申报要求，监测到您的订单中存在主体缺失订单，为了确保您的业务正常进行，请尽快上传缺失的订单。请根据“下载缺失订单信息”文件中的主体名单，上传相应的订单至订单库中。','In accordance with the international balance of payments declaration requirements of EasePay`s cooperative banks, it has been detected that there are orders with missing entities in your orders. To ensure  normal operation, please upload the missing orders as soon as possible.Please upload the corresponding orders to the order database according to the entity list in the "Download Missing Order Information" file.'],
  downloadOrderInfo: ['下载缺失订单信息','Download Missing Order Info'],
  batchNumber: ['批次号','Batch number'],
  batchNumber_label: ['批次号：','Batch number：'],
  batchNumber_placeholder: ['批次号','batch number'],
  transStatus_label: ['交易状态：','Transaction status：'],
  transStatus_placeholder: ['请选择','select'],
  transCreateDate_label: ['交易创建日期：','Trans create time：'],
  start_date: ['开始日期','start date'],
  end_date: ['结束日期','end date'],
  to: ['至','To'],
  search: ['查询','Inquiry'],
  export: ['导出','Export'],
  merchantNumber: ['商户号','Merchant number'],
  merchantNumber_label: ['商户号：','Merchant number：'],
  merchantNumber_placeholder: ['请输入商户号','enter merchantNumber'],
  merchantName: ['商户名称','Merchant name'],
  merchantName_label: ['商户名称：','Merchant name：'],
  merchantName_placeholder: ['请输入商户名称','enter merchantName'],
  collSettleList: ['收结汇列表','Coll& Settle List'],
  orderType: ['业务场景','Business scenario'],
  beneficiaryBank: ['收款银行','Beneficiary bank'],
  isDz: ['是否垫资','Fund advance'],
  tradeType: ['贸易类型','Trade type'],
  amount: ['发起额','Initiated amount'],
  otherCharge: ['中间行费','Intermed bank fee'],
  realAmount: ['银行实到','Actual bank rcv amt'],
  serviceCharge: ['手续费','Service fee'],
  settleAmount: ['结算额','Settled amount'],
  payVoucher: ['付款凭证','Payment voucher'],
  imgMaterials: ['影像资料','Image materials'],
  transStatus: ['交易状态','Transaction status'],
  businessScope: ['交易类型','Transaction type'],
  receiptFundSource: ['资金来源','Source of funds'],
  transCreateDate: ['交易创建日期','Trans create time'],
  transEndDate: ['交易完成日期','Trans comp time'],
  remark: ['备注','Remarks'],
  operation: ['操作','Operation'],
  advance: ['垫资','Advance'],
  noAdvance: ['不垫资','No Advance'],
  upload: ['上传','Upload'],
  uploaded: ['已上传','Uploaded'],
  noUpload: ['未上传','Not Uploaded'],
  download: ['下载','Download'],
  viewDisb: ['查看下发','View Disb'],
  uploadOrder: ['上传订单','Upload Orders'],
  downloadErrOrder: ['下载缺失订单','Download missing order info'],
  tradeTemplate: ['贸易模板','Trade template'],
  laborTemplate: ['劳务薪酬模板','Labor template'],
  collSettleTrans: ['收结汇交易','Coll& Settle trans'],
  tryAgain: ['请稍后重试','Try again later'],
  errorOrderInfo: ['缺失订单信息','Missing order info'],
  blackNameList: ['该商户位于黑名单 ～','On the blacklist～'],
  uploadSuccess: ['上传成功～','Upload succeeded～'],
  submitError: ['提交失败','Submit failed'],
  null: ['暂无数据','N/A'],
  initiate: {
    title: ['发起收结汇','Initiate Coll& Settle'],
    backList: ['返回列表','Back List'],
    orderType_label: ['业务场景：','Business scenario：'],
    orderType_placeholder: ['请选择业务场景','select business scenario'],
    businessScope_label: ['交易类型：','Transaction type：'],
    businessScope_placeholder: ['请选择交易类型','select transaction type'],
    receiptFundSource_label: ['资金来源：','Source of funds：'],
    receiptFundSource_placeholder: ['请选择资金来源','select source of funds'],
    beneficiaryBank_label: ['收款银行：','Benef bank：'],
    beneficiaryBank_placeholder: ['请选择收款银行','select benef bank'],
    payInfoTips: ['为保障入账成功，打款信息请务必严格按照如下信息填写','To ensure successful fund receipt, please fill in the remittance info. in strict accordance with the following details'],
    payer_label: ['收款人：','Payee：'],
    payAccount_label: ['收款人账号/IBAN：','IBAN：'],
    bankAddress_label: ['银行地址：','Bank address：'],
    receiverAddress_label: ['收款人地址：','Payee address：'],
    settleAmount_label: ['金额：','Amount：'],
    settleAmount_placeholder: ['请填写金额','enter amount'],
    yuan: ['元','CNY'],
    isDz_label: ['是否垫资：','Fund advance：'],
    isDz_placeholder: ['请选择是否垫资','select fund advance'],
    yes: ['是','YES'],
    no: ['否','NO'],
    uploadPayMaterials_label: ['上传打款凭证资料：','Upload pmt voucher mats：'],
    uploadPayMaterials_placeholder: ['请上传银行打款凭证','upload payment voucher materials'],
    paymentVoucher: ['银行打款凭证','Bank payment voucher'],
    bankDocument: ['银行报文','Bank message'],
    bankDocument_placeholder: ['请上传银行报文','upload bank message'],
    example: ['示例','Example'],
    uploadVoucherTips: ['注：上传打款凭证资料格式为.jpg或.pdf','Note: Upload payment voucher materials in .jpg or .pdf format'],
    downloadErrOrder_label: ['下载错误订单明细：','Download error order details：'],
    downloadErrorOrder: ['下载错误明细','Download error order details'],
    downloadErrorOrder_tips: ['注：下载的错误明细用于提示错误信息，请在上传的结汇订单明细文件中进行修改，修改成功后重新上传','Note: The downloaded error details are used to indicate error information. Please modify them in the uploaded foreign exchange settlement order details file and re-upload after successful modification.'],
    uploadOrder_label: ['上传订单明细：','Upload ord dtls：'],
    uploadOrder_placeholder: ['请上传订单明细','upload order details'],
    downloadOrderTemplate: ['下载订单明细模板','Download order details template'],
    uploadOrderTemplate_tips: ['注：上传的订单总金额必须大于等于发起金额，并且每次上传的订单明细模板中，只能包含一种贸易类型','Note: Total amount of uploaded orders must be greater than or equal to initiated amount, and each uploaded order details template can only contain one trade type'],
    uploadImgMaterials_optional_label: ['上传影像资料(选填)：','Upload image mats(Optional)：'],
    uploadImgMaterials_label: ['上传影像资料：','Upload image mats：'],
    uploadImgMaterials_placeholder: ['请上传影像资料','upload image materials'],
    uploadDocument_tips1: ['上传文件，包括但不限于：','Upload Files, Including but Not Limited To:'],
    uploadDocument_tips2: ['（1）合同、发票/形式发票、服务预订信息或凭证（机票 /酒店 /旅游 /签证&签注信息 (若有)/ 缴费通知单 /结算请求书 /其他）以及其他贸易相关的证明材料；','(1) Contracts, invoices/proforma invoices, service booking information or Certificates(flights/hotels/tourism/visa&Endorsement information(if applicable)/payment notices/settlement requests/others) and other trade-related supporting documents;'],
    uploadDocument_tips3: ['（2）上传订单明细，若包含超过180天订单，上传文件需包含延期订单说明函。','(2) Upload order details; if orders exceeding 180 days are included, the uploaded files must include a delayed order explanation letter.'],
    uploadDocument_tips4: ['其中，业务类型为对公的，上传文件需要加盖公章。','For corporate business types, the uploaded files must be affixed with an official seal.'],
    viewMaterialsRemark: ['影像资料说明','Image materials description'],
    uploadMaterials_tips: ['注：上传资料格式为.zip, .rar压缩包','Note: Upload materials in .zip or .rar compressed format'],
    prompt: ['提示','Prompt'],
    submitReg: ['收结汇申请已提交','Coll& Settle application submitted'],
    viewProgress: ['查看收结汇进度','View coll&settle progress'],
    goSettleDisb_tips: ['请前往“结汇下发”页面，查看下发进度，或者，提交新的下发请求','Please go to the "settle& disb" page to check the disb progress or submit a new disb request'],
    goSettleDisb: ['跳转至结汇下发','Jump to settle& disb'],
    close: ['关 闭','Close'],
    successSubmit: ['发起收结汇成功','Successfully initiated collection & settlement'],
    submitCollSettleError: ['提交失败，上传结汇订单明细有误，请下载错误订单明细进行修改，重新上传','Submission failed. There is an error in the uploaded settlement order details. Please download the error order details to modify and re-upload.'],
    submitOrderError: ['提交失败，上传订单明细有误，请下载错误订单明细进行修改，重新上传','Submission failed. There is an error in the uploaded settlement order details. Please download the error order details to modify and re-upload.'],
    deductionAcc: ['扣款账户','deduction account'],
  },
  batch: {
    title: ['收结汇订单库','Coll& Settle Order Database'],
    backList: ['返回列表','Back List'],
    batchStatus_label: ['批次处理状态：','Batch processing status：'],
    all: ['全部','all'],
    createDate_label: ['创建日期：','Create time：'],
    start_date: ['开始日期','start date'],
    end_date: ['结束日期','end date'],
    to: ['至','To'],
    search: ['查询','Inquiry'],
    orderBatch_title: ['订单批次管理','Order Batch Management'],
    batchNo: ['批次号','Batch NO'],
    fileName: ['文件名称','File name'],
    receiptCreateTime: ['结汇创建时间','Settlement creation time'],
    receiptBatchNo: ['结汇批次号','Settlement batch NO'],
    sumAmount: ['总金额','Total amt'],
    sumNumber: ['总笔数','Total number'],
    createdTime: ['创建时间','Creation time'],
    finishedTime: ['完成时间','Completion time'],
    batchStatus: ['批次处理状态','Batch processing status'],
    message: ['说明','Description'],
    operation: ['操作','Operation'],
    view: ['查看','View'],
    downloadErrOrder: ['下载错误订单','Download error order info'],
    download: ['下载','Download'],
    uploadSuccess: ['上传成功～','Upload success～'],
    submitOrderError: ['提交失败，上传订单明细有误，请下载错误订单明细进行修改，重新上传','Submission failed. There is an error in the uploaded settlement order details. Please download the error order details to modify and re-upload.'],
    errorOrderInfo: ['缺失订单信息','Missing order info'],
    tryAgain: ['请稍后重试','Try again later'],
  },
  detail: {
    title: ['收结汇 - 批次详情','Coll&Settle-Batch Details'],
    backList: ['返回列表','Back List'],
    export: ['导出','Export'],
    orderNumber: ['订单编号','Order NO'],
    tradeType: ['贸易类型','Trade type'],
    tradeCode: ['交易编码','Trade code'],
    payerCountryCode: ['打款国家','Remittance country'],
    payeeType: ['收款人类型','Payee type'],
    payeeName: ['收款人名称','Payee name'],
    payeeCertNo: ['收款人证件号','Payee cert. NO'],
    payeeTel: ['收款人电话','Payee phone'],
    currency: ['交易币种','Trans. currency'],
    exchangeRate: ['汇率','Exchange rate'],
    amount: ['收款金额','Received amt'],
    receiveType: ['收款类型','Received type'],
    transTime: ['交易日期','Trans. time'],
    platformName: ['商户平台名','Platform name'],
    goodsServiceType: ['商品名称/服务种类','Product name/Service type'],
    goodsServiceName: ['商品名称/服务名称','Product name/Service name'],
    goodsNumber: ['商品数量','Product quantity'],
    logisticsNumber: ['物流单号','Logistics tracking No'],
    logisticsCompany: ['物流公司','Logistics Co'],
    payeeAccountNo: ['收款人账号','Payee account No'],
    payeeBankName: ['收款银行名','Payee bank name'],
    payeeOpenCity: ['收款开户地市','City of receiving bank acct. opening'],
    actualAmount: ['订单实际金额','Actual order amt'],
    tryAgain: ['请稍后重试','Try again later'],
    batchInfo: ['收结汇批次订单详情','Coll& Settle batch order details'],
  },
  issued: {
    title: ['收结汇','Coll& Settle'],
    backList: ['返回列表','Back List'],
    issueList: ['下发列表','Issuance List'],
    export: ['导出','Export'],
    issueNo: ['下发编号','Issuance NO'],
    orderNumber: ['订单编号','Order NO'],
    payeeType: ['收款人类型','Payee type'],
    payeeName: ['收款人名称','Payee name'],
    payeeCertNo: ['收款人证件号','Payee cert. NO'],
    payeeAccountNo: ['银行账号','Bank account NO'],
    amount: ['交易金额','Amount'],
    tradeCode: ['国际收支编码','Balance code'],
    tradeType: ['贸易类型','Trade type'],
    finishedTime: ['下发时间','Issuance time'],
  },
  order: {
    title: ['收结汇订单库','Coll& Settle Order Database'],
    backList: ['返回列表','Back List'],
    platformOrderNo_label: ['平台订单号：','Platform order number：'],
    orderNumber: ['订单编号','Order NO'],
    orderNumber_label: ['订单编号：','Order NO：'],
    orderNumber_placeholder: ['订单编号','order NO'],
    orderStatus_label: ['订单状态：','Order status：'],
    tradeType: ['贸易类型','Trade type'],
    tradeType_label: ['贸易类型：','Trade type：'],
    tradeType_placeholder: ['贸易类型','trade type'],
    payeeType_label: ['收款人类型：','Payee type：'],
    all: ['全部','all'],
    search: ['查询','Inquiry'],
    orderList: ['订单列表','Orde List'],
    platformOrderNo: ['平台订单号','Platform order NO'],
    orderAmount: ['订单金额','Order amt'],
    payeeType: ['收款人类型','Payee type'],
    goodsServiceName: ['商品名称/服务名称','Product name/Service name'],
    goodsNumber: ['商品数量','Product quantity'],
    status: ['订单状态','Order status'],
  },
  record: {
    title: ['企业汇款人备案','Enterprise Remitter Filing'],
    addRecord: ['新增备案','Add Filing'],
    waterNo_label: ['流水号：','Serial NO：'],
    waterNo_placeholder: ['流水号','serial NO'],
    waterNo: ['流水号','Serial NO'],
    busName_label: ['企业名称：','Enterprise name：'],
    busName_placeholder: ['请输入企业名称','please enter the enterprise name'],
    busName_placeholder2: ['企业名称','enterprise name'],
    busName: ['企业名称','Enterprise name'],
    busNo_label: ['资质证件号：','Qualification certificate NO：'],
    busNo_placeholder: ['请输入资质证件号','please enter the qualification certificate NO'],
    busNo_placeholder2: ['资质证件号','qualification certificate NO'],
    busNo: ['资质证件号','Qualification certificate NO'],
    status_label: ['备案状态：','Filing status：'],
    status_placeholder: ['请选择','select'],
    search: ['查询','Inquiry'],
    reset: ['重置','Reset'],
    busRegMaterials: ['企业注册资料','Enterprise reg. materials'],
    busRegMaterials_label: ['企业注册资料：','Enterprise reg. materials：'],
    busRegMaterials_placeholder: ['请上传企业注册资料','please upload enterprise reg. Materials'],
    recordStatus: ['备案状态','Filing status'],
    remark: ['说明','Remark'],
    download: ['下载','Download'],
    note: ['注：','Note：'],
    uploadMaterials_tips1: ['上传资料格式为.zip, .rar压缩包；','Upload materials in .zip or .rar compressed format;'],
    uploadMaterials_tips2: ['企业注册资料是指企业资质证书，但您名下前三个企业备案时还需额外提供用工方与机构的发薪协议、工资单、工作证明这三个文件，其中工作证明是指含有姓名、职位、身份证号、薪资、入职时间等要素的劳动合同或用工方代薪名单。','Enterprise reg. materials refer to enterprise qualif. certs. However, when filing for your first three enterprises, you need to additionally provide three documents: the salary payment agreement between the employer and the institution, payroll slips, and employment certs. Among them, an employment cert. refers to a labor contract or a salary list on behalf of the employer that includes elements such as name, position, ID number, salary, and employment date.'],
    cancel: ['取 消','Cancel'],
    submit: ['确 定','Submit'],
    submitSuccess: ['添加成功～','Addition succeeded～'],
    submitFail: ['添加失败～','Addition failed～'],
  },
}